import { Buffer } from "buffer";
import * as THREE from "three";

const convertRawData = async (rawData) => {
  const buffer = await rawData.async("arraybuffer");
  return Buffer.from(buffer);
};

export const getRawDataFromToothNumberRaw = async (rawData) => {
  let buf = await convertRawData(rawData);
  const data = [];

  for (let ii = 1; ii <= buf.readInt32LE(0); ii++) {
    data.push(buf.readInt32LE(ii * 4));
  }

  return data;
};

export const getRawDataFromToothMatrixRaw = async (rawData) => {
  let buf = await convertRawData(rawData);

  const mats = [];
  for (let ii = 0; ii < buf.readInt32LE(0); ii++) {
    let mat = new THREE.Matrix4();
    let elems = new Array(16);
    for (let mm = 0; mm < 16; mm++) {
      elems[mm] = parseFloat(buf.readFloatLE(4 + mm * 4 + ii * 16 * 4));
    }
    mat.fromArray(elems);
    mat.transpose();
    mats.push(mat);
  }

  return mats;
};

export const getRawDataFromGumMatrixRaw = async (rawData) => {
  let buf = await convertRawData(rawData);
  const mat = new THREE.Matrix4();
  mat.elements.splice(0);
  for (let ii = 0; ii < 16; ii++) {
    mat.elements[ii] = buf.readFloatLE(ii * 4);
  }
  mat.transpose();
  return mat;
};

export const getRawDataFromVisibilityRaw = async (rawData) => {
  let buf = await convertRawData(rawData);

  const data = [];

  for (let ii = 1; ii <= buf.readInt32LE(0); ii++) {
    data.push(buf.readInt32LE(ii * 4));
  }

  return data;
};

export const getRawDataFromIPRRaw = async (rawData) => {
  let buf = await convertRawData(rawData);

  const ipr_data = [];
  let byte_offset = 0;

  for (let ii = 0; ii < buf.readInt32LE(0); ii++) {
    const ipr = {};
    ipr.tooth1 = buf.readInt32LE(byte_offset + 4);
    ipr.tooth2 = buf.readInt32LE(byte_offset + 8);
    ipr.IPRValue = buf.readDoubleLE(byte_offset + 12);

    // TODO: convert to threejs vertex
    ipr.centerPosition = new THREE.Vector3(
      buf.readDoubleLE(byte_offset + 20),
      buf.readDoubleLE(byte_offset + 28),
      buf.readDoubleLE(byte_offset + 36)
    );

    const num_points = buf.readInt32LE(byte_offset + 44);

    // vertices are used to create collection faces
    ipr.vertices = new Array(num_points);
    for (let pp = 0; pp < buf.readInt32LE(byte_offset + 44); pp++) {
      ipr.vertices[pp * 3] = buf.readDoubleLE(byte_offset + 48 + pp * 24);
      ipr.vertices[pp * 3 + 1] = buf.readDoubleLE(byte_offset + 56 + pp * 24);
      ipr.vertices[pp * 3 + 2] = buf.readDoubleLE(byte_offset + 64 + pp * 24);
    }
    ipr.vertices = new Float32Array(ipr.vertices);
    ipr_data.push(ipr);
    byte_offset += 68 + (num_points - 1) * 24;
  }

  return ipr_data;
};
